import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { motion } from "framer-motion";

import "swiper/css";
import "swiper/css/pagination";

const products = [
  {
    name: "Mango",
    category: "Other",
    image: "/assets/product-images/Mango.png",
    desc: "Tropical richness crafted with the luscious taste of ripe mangoes.",
    bgColor: "#6f6f2e8a"
  },
  {
    name: "Chikoo",
    category: "Fruits",
    image: "/assets/product-images/Chiiku.png",
    desc: "Creamy perfection blended with the naturally sweet flavour of ripe chikoo.",
    bgColor: "#6f6f2e8a"
  },
  {
    name: "BiScoff",
    category: "Chocolate",
    image: "/assets/product-images/Biscoff.png",
    desc: "Creamy gelato swirled with the caramelised crunch of Biscoff biscuits.",
    bgColor: "#6f6f2e8a"
  },
  {
    name: "TiramiSu",
    category: "Other",
    image: "/assets/product-images/Tiramisu.png",
    desc: "A luxurious Italian classic layered with creamy coffee delight.",
    bgColor: "#6f6f2e8a"
  },
  {
    name: "Choco Hazelnut",
    category: "Chocolate",
    image: "/assets/product-images/Choco Hazlennut.png",
    desc: "A luxurious blend of rich chocolate and roasted hazelnut goodness.",
    bgColor: "#6f6f2e8a"
  },
  
  
];

function Classic() {
  return (
    <section className="classic-con position-relative">

      <figure className="classic-leftimage mb-0">
        <img src="/assets/images/classic-leftimage.png" alt="img" />
      </figure>

      <figure className="classic-rightimage mb-0">
        <img src="/assets/images/classic-rightimage.png" alt="img" />
      </figure>

      <div className="container">

        
        {/* HEADING ANIMATION ONLY */}
        <motion.div
          className="text-center classic_content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h2>
            Our <span>Signature</span> FlavorS
          </h2>
          <p>
            Explore our delicious range of handcrafted gelato flavors.
          </p>
        </motion.div>

        {/* PRODUCTS (NO ANIMATION) */}
        <Swiper
          modules={[Pagination]}
          spaceBetween={30}
          slidesPerView={3}
          pagination={{ clickable: true }}
          breakpoints={{
            320: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {products.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="classic-box">

                <div className="classic_image_box">
                  <div
                    className="image-bg"
                    style={{ backgroundColor: item.bgColor }}
                  >
                    <img src={item.image} alt={item.name} />
                  </div>
                </div>

                <div className="classic_box_content">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6>{item.name}</h6>
                  </div>

                  <p>{item.desc}</p>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

       
      </div>
    </section>
  );
}

export default Classic;